export enum TicketStatus {
  OFFEN = 'OFFEN',
  IN_BEARBEITUNG = 'IN_BEARBEITUNG',
  ERLEDIGT = 'ERLEDIGT',
  ZURUECKGESTELLT = 'ZURUECKGESTELLT',
}
